<template>
  <magic-ui-button
    ref="button"
    class="magic-ui-link magic-ui-link__btn"
    :config="config"
    :style="{color: config.style.color}"
  >
    <!-- 微信环境下，版本7.0.12以上，可以使用此标签拉起小程序 -->
    <wx-open-launch-weapp
      v-if="weappConfig && supportWeappTag"
      class="magic-ui-link__weapptag"
      :username="weappConfig.userName"
      :path="weappConfig.path"
    >
      <script type="text/wxtag-template">
        <style>.btn { opacity: 0; width: 100%; height: {{ elHeight }} }</style>
        <div class="btn"></div>
      </script>
    </wx-open-launch-weapp>
  </magic-ui-button>
</template>

<script>
import Version from '@tencent/vft-common/Version';

export default {
  name: 'MagicUiLink',

  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },

    model: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
  },

  computed: {
    elHeight() {
      // wx-open-launch-weapp 内容高度占不满，这里需要动态计算高度占满，而且这里不能使用rem单位
      const { height = 100 } = this.config.style || {};
      return `${height / 100 * parseFloat(getComputedStyle(document.documentElement).fontSize)}px`;
    },
    weappConfig() {
      const { openType, userName, path: url = '' } = this.config.urlButton || {};
      if (openType !== 'weapp') return null;
      const [path = '', query = ''] = url.split('?');
      return {
        userName: `${userName}`,
        path: `${path}.html?${query}`,
      };
    },
    supportWeappTag() {
      if (!this.env.isWechat) return false;
      const v = navigator.userAgent.match(/MicroMessenger\/([\d.]+)/i)?.[1];
      return Version.compare(v, '7.0.12');
    },
  },

  mounted() {
    this.initHandler();
  },

  methods: {
    initHandler() {
      const { pushHandler } = this.$refs.button;
      const { url: href, ...params } = this.config.urlButton || {};
      const url = href || this.config.href;
      const { openInNewWindow = false } = this.config;
      pushHandler(() => {
        this.app.openUrl(url, {
          ...params,
          forceOpenApp: params.openType === 'inApp',
          openInNewWindow,
        });
      });
    },
  },
};
</script>
